import VerificationEmail from './verification-email';

export default VerificationEmail;
